import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CoinTab } from '@coin/shared/core/util-models';

/**
 * @deprecated Use `coin-v2-dialog-frame` with `coin-v2-tabs` instead.
 */
@Component({
  selector: 'coin-c-dialog-tab-header',
  templateUrl: './dialog-tab-header.component.html',
  styleUrls: ['./dialog-tab-header.component.scss'],
  standalone: false
})
export class DialogTabHeaderComponent {
  @Input() title: string;
  @Input() tabs: CoinTab[];
  @Input() titleContainer?: TemplateRef<unknown>;
  @Input() actionContainerLeft?: TemplateRef<unknown>;
  @Input() actionContainerMiddle?: TemplateRef<unknown>;
  @Input() actionContainerRight?: TemplateRef<unknown>;
  @Input() withoutRouting: boolean;
  @Input() showCurrencySelection: boolean;

  @Output() closeClick = new EventEmitter<MouseEvent>();
  @Output() tabChange = new EventEmitter<number>();

  // check if parent component attached event listener (closeClick)="..."
  get displayCloseButton(): boolean {
    return this.closeClick.observers.length > 0;
  }
}
